module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [(_vm.$route.path.indexOf('templ') === -1) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6,
      "lg": 4,
      "xl": 3
    }
  }, [_c('div', {
    staticClass: "template-item add-btn",
    on: {
      "click": _vm.chooseTemp
    }
  }, [_c('div', {
    staticClass: "template-wrap add-btn"
  }, [_c('i', {
    staticClass: "iconfont icon-weixin"
  }), _vm._v(" "), _c('div', [_vm._v("添加小程序模板")])])])]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('el-col', {
      key: item.index,
      attrs: {
        "xs": 12,
        "sm": 8,
        "md": 6,
        "lg": 4,
        "xl": 3
      }
    }, [_c('div', {
      staticClass: "template-item"
    }, [(item.is_weapp_grade) ? _c('div', {
      staticClass: "has-upgrade"
    }) : _vm._e(), _vm._v(" "), (item.wxaCodeVisible) ? _c('div', {
      staticClass: "wxcode"
    }, [_c('div', {
      staticClass: "iconfont icon-times",
      on: {
        "click": function($event) {
          return _vm.closeWxcode(index)
        }
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.wxaCodeImage,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "template-wrap"
    }, [_c('div', {
      staticClass: "template-img"
    }, [(item.template_name === 'yykmembership') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykmendian') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_01.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykcutdown') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_02.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykweishop') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_04.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykcommunity') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_07.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykcommunitypms') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_06.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.is_bind) ? _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (item.loading),
        expression: "item.loading"
      }],
      staticClass: "demo-qrcode",
      on: {
        "click": function($event) {
          return _vm.downloadWxaCode(index, item.bindInfo.authorizer_appid)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../static/img/code.png"),
        "height": "34",
        "width": "35",
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "template-caption"
    }, [_vm._v("\n            " + _vm._s(item.templateInfo.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "template-opend-btn",
      on: {
        "click": function($event) {
          return _vm.linkTo(item)
        }
      }
    }, [(item.is_bind) ? _c('span', [_vm._v("编辑模板")]) : _c('span', [_vm._v("未绑定")])])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b21c9c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b21c9c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/index.vue
// module id = 2635
// module chunks = 0